import React, { Component } from 'react';
import { observer } from 'mobx-react';

import CastleBuilding from '../buildings/Castle';
import ShopBuilding from '../buildings/shop/Screen';
import ForgeBuilding from '../buildings/Forge';
import AvatarShop from '../buildings/AvatarShop';
import Portal from '../buildings/Portal';
import Arena from '../buildings/Arena';

import { checkIsFull } from './Island/IslandScreen';

import heroStore from '../stores/hero';
import appStore from '../stores/app';

import { getBuilding } from '../utils/buildingUtils';

import { BUILDING_MODULES } from '../lib/constants';

export function moveToBuilding(id: string) {
  if (!checkIsFull()) return false;
  heroStore.moveToBuilding(id);
  return undefined;
}

@observer
export default class BuildingScreen extends Component<{}> {
  render() {
    const { location } = heroStore.hero;

    const building = getBuilding(appStore.initData.buildings, location.building!);
    if (!building) return null;

    const params: any = building.params || {};

    switch (building.module) {
      case BUILDING_MODULES.CASTLE:
        return <CastleBuilding id={building.id} />;
      case BUILDING_MODULES.SHOP.NAME:
        return (
          <ShopBuilding
            sell={params.sell}
            dressable={params.dressable}
            id={building.id}
            suppressFilter={params.suppressFilter}
          />
        );
      case BUILDING_MODULES.FORGE.NAME:
        return <ForgeBuilding id={building.id} />;
      case BUILDING_MODULES.AVATAR_SHOP.NAME:
        return <AvatarShop id={building.id} />;
      case (BUILDING_MODULES as any).PORTAL.NAME:
        return <Portal id={building.id} />;
      case (BUILDING_MODULES as any).ARENA.NAME:
        return <Arena id={building.id} />;
      default:
        return null;
    }
  }
}
